import { Flex } from '@chakra-ui/react';

import { Header } from '../../components';

import { AddResponsibleForm } from './AddResponsibleForm';

const ROOT_ENTITY = 'onboarding/addResponsible';

export const AddResponsible = () => {
  return (
    <Flex
      flexDir="column"
      w="full"
      p={10}
      maxH="100dvh"
      h="100%"
      align="center"
    >
      <Flex flexDir="column" gap={6} w="full" maxW="700px">
        <Header rootEntity={ROOT_ENTITY} />

        <AddResponsibleForm rootEntity={ROOT_ENTITY} />
      </Flex>
    </Flex>
  );
};
